import { useNavigate } from 'react-router-dom'

import { Button } from '../../../components/Button/Button'

export const DocumentBatchHeader: React.FC = () => {
  const navigate = useNavigate()

  const handleBackButtonClicked = () => {
    navigate('/documents/upload')
  }

  return (
    <div className='d-flex zocks-pl-2.0 justify-content-between align-items-center'>
      <Button variant='header' className='zocks-p-0.625' onClick={handleBackButtonClicked}>
        <i className='bi bi-chevron-left' />
      </Button>
    </div>
  )
}
